import { RouteObject } from "react-router";
import { DocumentCenter } from "./DocumentCenter";

export const routes = (basePath: string): RouteObject[] => [
  {
    path: basePath,
    children: [
      {
        path: "*",
        element: <DocumentCenter />,
      },
    ],
  },
];
